import React from 'react';
import { Box, FormControl, FormLabel, Input, Tag, Text, Textarea } from '@chakra-ui/react';
import { TranslatableItem } from '@common/entities';

interface TranslatableFieldProps {
  item: TranslatableItem;
  overrideValue: string;
  onChange: (value: string) => void;
}

export function TranslatableField({ item, overrideValue, onChange }: TranslatableFieldProps) {
  const isLongText = item.defaultValue.length > 100;

  return (
    <Box
      p={3}
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      _hover={{ borderColor: 'gray.300' }}
    >
      <FormControl>
        <FormLabel fontSize="xs" fontWeight="medium" color="gray.500" mb={1}>
          <Tag size="sm" colorScheme="gray" mr={2}>
            {item.label}
          </Tag>
        </FormLabel>
        {item.contextPath && item.contextPath.length > 0 && (
          <Box mb={2}>
            {item.contextPath.map((context) => (
              <Tag key={`${item.key}-${context}`} size="sm" colorScheme="blue" mr={2} mb={1}>
                {context}
              </Tag>
            ))}
          </Box>
        )}
        <Text fontSize="sm" color="gray.700" mb={2}>
          {item.defaultValue}
        </Text>
        {isLongText ? (
          <Textarea
            value={overrideValue}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Enter translation..."
            fontSize="sm"
            size="sm"
            rows={3}
            resize="vertical"
          />
        ) : (
          <Input
            value={overrideValue}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Enter translation..."
            fontSize="sm"
            size="sm"
          />
        )}
      </FormControl>
    </Box>
  );
}
